import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classnames from "classnames"

import styles from "./index.less"

export default class Cover extends C {
  static defaultProps = {
    url: null,
    shape: "square",
  }

  static propTypes = {
    className: PropTypes.string,
    url: PropTypes.string,
    shape: PropTypes.oneOf(["circle", "square"]),
  }

  get shapes() {
    return {
      circle: styles.circle,
      square: "",
    }
  }

  render() {
    let inlineStyle = { backgroundImage: `url(${this.props.url})` }

    let imageClassName = classnames(
      styles.cover,
      this.shapes[this.props.shape],
      this.props.className,
    )

    return (
      <div
        style={inlineStyle}
        className={imageClassName}
        title={this.props.title}
        onClick={this.props.onClick}
        data-qa={this.props["data-qa"]}
      />
    )
  }
}
